import React, {useState, useEffect} from "react";
import CalendarIntensityMonth from "../components/CalendarIntensityMonth";

export default function CalendarIntensity({calendarObject}){
	
	
	const [calendarMonths, setCalendarMonths] = useState([]);
	
	useEffect(() => {
   if(calendarObject && calendarObject.calendarMonths){
   	setCalendarMonths(calendarObject.calendarMonths)
   }
  }, [calendarObject]);
	
  const thisContainer = {
    display: "flex",
    flexDirection: "column",
    minWidth: "300px",
    background: "linear-gradient(180deg, #171a1f 0%, #0f1115 100%)",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.06)",
    boxShadow: "0 6px 14px rgba(0,0,0,0.28)",
    padding: "10px",
    gap: "10px",
    marginBottom: "20px",
	alignSelf: "flex-start",
	paddingBottom:'20px'
  };
	
	const calendarMonthDisplay = calendarMonths.map((item, index) =>
		<CalendarIntensityMonth
			calendarMonth={item}
		/>
	);
	
	return (
		<div style={thisContainer}>
			{calendarMonthDisplay}
		</div>
	);
}